import Vue from 'vue'
import VueGtag from 'vue-gtag'

export default ({ app }) => {
  Vue.use(
    VueGtag,
    {
      config: { id: process.env.googleTagManagerId },
      includes: [{ id: process.env.googleAnalitycs4Id }],
      appName: 'Relink',
      pageTrackerScreenviewEnabled: true,
    },
    app.router
  )
}
